import { render, staticRenderFns } from "./TheoryRatingDanish.vue?vue&type=template&id=7345f2ad"
import script from "./TheoryRatingDanish.vue?vue&type=script&lang=js"
export * from "./TheoryRatingDanish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports